import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { AttachmentModel } from "@/common/models/attachment.model";

export class AttachmentsApiService extends ApiService {
  static endpoint = 'attachments';

  /**
   * @param {Number|null} id
   * @return {String}
   * @protected
   */
  static buildAttachmentUrl(id = null) {
    return this.buildUrl(id);
  }

  /**
   * @param {String|Number} id
   * @param {builderCallback | null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<AttachmentModel>>}
   * @public
   */
  static async get(id, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildAttachmentUrl(id), {
      ...config,
      dataModel: AttachmentModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {Object} data
   * @param {builderCallback | null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<AttachmentModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(), data, {
      ...config,
      dataModel: AttachmentModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   *
   * @param id
   * @param builderCallback
   * @param config
   * @returns {Promise<HttpResponse>}
   */
  static async delete(id, builderCallback = null, config = {}) {
    return HttpApiClient.delete(this.buildAttachmentUrl(id), {
      ...config,
      dataModel: AttachmentModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
